import React from 'react';
type Heading2Props = {
  children: React.ReactNode;
  className?: string;
};
export function Heading2({
  children,
  className = ''
}: Heading2Props) {
  return <h2 className={`text-center text-[26px] font-extrabold underline decoration-2 underline-offset-[6px] md:text-[34px] ${className}`} style={{
    fontWeight: "700"
  }} data-id="element-24" data-mp="3i15qo9qwo5ix">
      {children}
    </h2>;
}